/**
 * Clinch Motion presets — durations align with colors.css transition tokens.
 * @see https://motion.dev/docs/vue
 */

export const DURATION = {
  fast: 0.15,
  base: 0.3,
  slow: 0.5
}

export const EASE = [0.4, 0, 0.2, 1]

export const motionPresets = {
  fade: {
    initial: { opacity: 0 },
    animate: { opacity: 1 },
    exit: { opacity: 0 },
    transition: { duration: DURATION.base, ease: EASE }
  },
  slideUp: {
    initial: { opacity: 0, y: 12 },
    animate: { opacity: 1, y: 0 },
    exit: { opacity: 0, y: 8 },
    transition: { duration: DURATION.base, ease: EASE }
  },
  slideInLeft: {
    initial: { opacity: 0, x: -24 },
    animate: { opacity: 1, x: 0 },
    exit: { opacity: 0, x: -16 },
    transition: { duration: DURATION.base, ease: EASE }
  },
  slideInRight: {
    initial: { opacity: 0, x: 24 },
    animate: { opacity: 1, x: 0 },
    exit: { opacity: 0, x: 16 },
    transition: { duration: DURATION.base, ease: EASE }
  },
  scaleIn: {
    initial: { opacity: 0, scale: 0.96 },
    animate: { opacity: 1, scale: 1 },
    exit: { opacity: 0, scale: 0.98 },
    transition: { duration: DURATION.fast, ease: EASE }
  },
  tap: {
    whileTap: { scale: 0.97 },
    transition: { type: 'spring', stiffness: 500, damping: 30 }
  },
  hover: {
    whileHover: { y: -1 },
    transition: { duration: DURATION.fast, ease: EASE }
  },
  springSnappy: {
    transition: { type: 'spring', stiffness: 400, damping: 28 }
  },
  staggerContainer: {
    initial: {},
    animate: {
      transition: {
        staggerChildren: 0.06,
        delayChildren: 0.04
      }
    }
  },
  staggerItem: {
    initial: { opacity: 0, y: 10 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: DURATION.base, ease: EASE }
  },
  inView: {
    initial: { opacity: 0, y: 16 },
    animate: { opacity: 1, y: 0 },
    whileInView: { opacity: 1, y: 0 },
    viewport: { once: true, margin: '-40px' },
    transition: { duration: DURATION.base, ease: EASE }
  }
}

export const REDUCED_MOTION_TRANSITION = { duration: 0 }

export function getPreset(name) {
  return motionPresets[name] || motionPresets.fade
}
